/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */
(function () {
    function treatment() {
        const anchor = document.querySelector('h2.section-header__title').closest('.shopify-section');
        if (!anchor) {
            return;
        }

        const container = document.createElement('div');
        container.className = 'index-section registry';
        container.innerHTML = `
            <div class="page-width">
                <div class="inner is-flex align-items-center">
                    <div class="flex-1 descr">
                        <h2>GIFT REGISTRY</h2>
                        <p>Create and share a gift registry at Australia’s one-stop baby shop. Metro Baby has an extensive curated range of top baby brands and products.</p>
                    </div>
                    <div class="flex-1 image-holder">
                        <img src="https://cdn.shopify.com/s/files/1/0256/1471/2913/files/w32_registry-bg.png?v=1733708511">
                    </div>
                    <div class="flex-1 links">
                        <div class="link-item">
                            <a href="/pages/gift-registry?mrsearch=%20"><span>SEARCH REGISTRY</span> <span class="icon-arrow-right"></span></a>
                        </div>
                        <div class="link-item">
                            <a href="/pages/gift-registry?mrlogin=1"><span>MANAGE REGISTRY</span> <span class="icon-arrow-right"></span></a>
                        </div>
                        <div class="link-item">
                            <a href="/pages/gift-registry?mrsignup=1"><span>CREATE NEW REGISTRY</span> <span class="icon-arrow-right"></span></a>
                        </div>
                    </div>
                </div>
            </div>
        `;

        anchor.insertAdjacentElement('afterend', container);
    }

    function trigger() {
        if (location.pathname === '/') {
            Mojito.utils.waitForElement('h2.section-header__title', treatment);
        }
    }

    trigger();
})();

